module.exports = __webpack_public_path__ + "img/emm_icon02.31a1db07.png";